export const getFillColorFunctionMapping = {
  default_point: (v) => {
    return [204, 51, 51];
  },
  default_polygon: (v) => {
    return [204, 51, 51];
  },
  secondary_point: (v) => {
    return [0, 0, 0];
  },
  secondary_polygon: (v) => {
    return [0, 0, 0];
  },
  tertiary_point: (v) => {
    return [48, 79, 254];
  },
  tertiary_polygon: (v) => {
    return [48, 79, 254];
  },
};

export const getPointRadiusFunctionMapping = {
  default_point: (v) => {
    return 5;
  },
  default_polygon: (v) => {
    return 5;
  },
  secondary_point: (v) => {
    return 5;
  },
  secondary_polygon: (v) => {
    return 5;
  },
  tertiary_point: (v) => {
    return 5;
  },
  tertiary_polygon: (v) => {
    return 5;
  },
};

export const getLineColorFunctionMapping = {
  default_line: (v) => {
    return [204, 51, 51];
  },
  secondary_line: (v) => {
    return [0, 0, 0];
  },
  tertiary_line: (v) => {
    return [48, 79, 254];
  },
};

export const getLineWidthFunctionMapping = {
  default_line: (v) => {
    return 4;
  },
  secondary_line: (v) => {
    return 4;
  },
  tertiary_line: (v) => {
    return 4;
  },
};

const uiReferenceMapping = [
  {
    id: 'default_line',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getLineColor: 'default_line',
      getLineWidth: 'default_line',
    },
  },
  {
    id: 'default_point',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'default_point',
      getPointRadius: 'default_point',
    },
  },
  {
    id: 'default_polygon',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'default_polygon',
      getPointRadius: 'default_polygon',
    },
  },
  {
    id: 'secondary_line',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getLineColor: 'secondary_line',
      getLineWidth: 'secondary_line',
    },
  },
  {
    id: 'secondary_point',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'secondary_point',
      getPointRadius: 'secondary_point',
    },
  },
  {
    id: 'secondary_polygon',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'secondary_polygon',
      getPointRadius: 'secondary_polygon',
    },
  },
  {
    id: 'tertiary_line',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getLineColor: 'tertiary_line',
      getLineWidth: 'tertiary_line',
    },
  },
  {
    id: 'tertiary_point',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'tertiary_point',
      getPointRadius: 'tertiary_point',
    },
  },
  {
    id: 'tertiary_polygon',
    attr: {
      title: 'Data',
      visible: true,
      opacity: 0.95,
      legend: {},
      getFillColor: 'tertiary_polygon',
      getPointRadius: 'tertiary_polygon',
    },
  },
];

export const getAttributesFromId = (id) => {
  let ans = {};
  uiReferenceMapping.forEach((map) => {
    if (map.id === id) {
      ans = map.attr;
    }
  });
  return ans;
};
